//@flow
import React from 'react'
import classnames from 'classnames'

import { Flex } from '..'
import { usePathLocationStyles } from './styles'
import { useI18n } from '~/core/i18n'

type PathLocationProps = {
  path: string[],
  activeSegment?: string,
  onPathChange: (path: string[]) => void
}

const PathLocation = ({ path, onPathChange, ...props }: PathLocationProps) => {
  const [msg] = useI18n()
  const classes = usePathLocationStyles()

  const handleSegmentClick = segment => {
    const newPath = path.slice(0, path.indexOf(segment) + 1)
    return onPathChange(newPath)
  }

  const handleRootSegmentClick = () => onPathChange([])

  return (
    <Flex className={classes.pathLocationWrapper} {...props}>
      <span
        className="path-location-segment root"
        title={msg('common.fileManager.homeFolder')}
        onClick={handleRootSegmentClick}
      >
        <i className="icon">home</i>
      </span>
      <span className="path-separator">/</span>
      {path.map((segment, idx) => {
        const isCurrent = path.length - 1 === idx
        return (
          <span key={segment + idx}>
            <span
              className={classnames('path-location-segment', {
                active: isCurrent
              })}
              onClick={() => !isCurrent && handleSegmentClick(segment)}
            >
              {segment}
            </span>
            <span className="path-separator">/</span>
          </span>
        )
      })}
    </Flex>
  )
}

export default PathLocation
